import {MODAL_SHOW, MODAL_HIDE} from '../../../constants';
import * as Immutable from 'immutable';

const initialState = Immutable.fromJS({status: 'HIDE', title: '', content: '', buttons: []});

/**
 *
 * @param state
 * @param action
 * @returns {*}
 */
export function modal(state = initialState, action) {
    switch (action.type) {
        case MODAL_SHOW:
            action.data.status = 'SHOW';
            return state.merge(action.data);
        case MODAL_HIDE:
            return state.merge({status: 'HIDE'});
        default:
            return state;
    }
}
